import { CONST } from 'CONST';
import { call_api_v2 } from './apiSrv';

function createApiRequestBody({
  serviceName,
  serviceVersion = 'v1',
  resourceName,
  resourceVersion = 'v1',
  actionName,
  actionVersion = 'v1',
  data,
} = {}) {
  // Input validation
  if (!serviceName || !resourceName || !actionName || data === undefined) {
    throw new Error(
      `Missing required fields: ${[
        !serviceName && 'serviceName',
        !resourceName && 'resourceName',
        !actionName && 'actionName',
        data === undefined && 'data',
      ]
        .filter(Boolean)
        .join(', ')}`
    );
  }

  // Validate version strings
  if (
    !/v\d+/.test(serviceVersion) ||
    !/v\d+/.test(resourceVersion) ||
    !/v\d+/.test(actionVersion)
  ) {
    throw new Error('Version fields must follow format "v<number>" (e.g., "v1")');
  }

  return {
    service: { name: serviceName, version: serviceVersion },
    resource: { name: resourceName, version: resourceVersion },
    action: { name: actionName, version: actionVersion },
    data,
  };
}


async function makeApiRequest({
  serviceName = 'entity',
  actionName = 'registration',
  resourceName = 'intermediary',
  data,
}
) {
  try {
    const body = createApiRequestBody({
      serviceName,
      resourceName,
      actionName,
      data,
    });

    const response = await call_api_v2(body, CONST.CONFIG);
    return response;
  } catch (err) {

    const error = err instanceof Error ? err : new Error('Unknown API error');
    throw new Error(
      `API request failed for action "${actionName}": ${error.message}`
    );
  }
}

export { createApiRequestBody, makeApiRequest };